import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WhatWeDo from "@/components/WhatWeDo";
import Platforms from "@/components/Platforms";
import CxApproach from "@/components/CxApproach";
import Impact from "@/components/Impact";
import Founder from "@/components/Founder";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const HomePage = () => (
  <div className="relative">
    <Navbar />
    <main>
      <Hero />
      <WhatWeDo />
      <Platforms />
      <CxApproach />
      <Impact />
      <Founder />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "rgba(11,16,30,0.9)",
              border: "1px solid rgba(0,240,255,0.2)",
              color: "#fff",
              backdropFilter: "blur(20px)",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
